import { render, staticRenderFns } from "./InstagramScenarioPreviewDialog.vue?vue&type=template&id=516dabfd&scoped=true"
import script from "./InstagramScenarioPreviewDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./InstagramScenarioPreviewDialog.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./InstagramScenarioPreviewDialog.vue?vue&type=style&index=0&id=516dabfd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "516dabfd",
  null
  
)

export default component.exports